<script lang="ts" setup></script>

<template>
  <svg
    class="rotate-90"
    fill="currentColor"
    height="18"
    viewBox="0 0 256 256"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M200,40H56A16,16,0,0,0,40,56V200a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40ZM56,56h64V200H56ZM200,200H136V56h64V200Z"
    />
  </svg>
</template>
